(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/notifications/components/marketplace.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/notifications/components/marketplace.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  Fieldset,
  Checkbox
} = svs.ui.reactForm;
const {
  TopHeader
} = svs.myProfile.react.shared.components;
const {
  useMarketplace
} = svs.myProfile.react.pages.notifications.hooks;
const {
  notificationsMarketplaceService
} = svs.myProfile.react.pages.notifications;
const {
  trackMarketplace
} = svs.myProfile.react.shared.tracking;
const {
  showSettingsTechnicalError
} = svs.myProfile.react.shared.dialogs;
const {
  titles,
  icons
} = svs.myProfile.constants;
const ID = ['SvS_TB_marketplace_wagerCreated_o2k', 'SvS_TB_marketplace_shareRefunded_o2k'];

const Marketplace = _ref => {
  let {
    setShouldShowApiError
  } = _ref;
  const [playerMarketplaceData, setPlayerMarketplaceData] = React.useState();
  const [isPlayerLoggedIn] = React.useState(svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER));
  useMarketplace(setPlayerMarketplaceData, setShouldShowApiError);
  const findIdInfo = id => {
    const notification = playerMarketplaceData.find(item => item.notificationType === id);
    const checked = notification.transports.find(item => item.transportType === 'Mail');
    return {
      notification,
      checked
    };
  };
  const handleMarketplaceCheckbox = async isChecked => {
    svs.myProfile.logger.debug("**** main handleMarketplaceCheckbox");
    const transportType = {
      enabled: !isChecked,
      transportType: 'Mail'
    };
    const newModel = playerMarketplaceData.slice();
    ID.forEach(id => {
      const {
        notification
      } = findIdInfo(id);
      const mailNotificationIndex = notification.transports.findIndex(item => item.transportType === 'Mail');
      const transportArray = notification.transports.slice();
      transportArray[mailNotificationIndex] = transportType;
      const newNotification = _objectSpread(_objectSpread({}, notification), {}, {
        transports: transportArray
      });
      const notificationIndex = playerMarketplaceData.findIndex(item => item.notificationType === id);
      newModel[notificationIndex] = newNotification;
    });
    if (isPlayerLoggedIn) {
      try {
        const {
          status,
          error
        } = await notificationsMarketplaceService.putCustomersMarketplaceDataItemsAsync(newModel);
        if (error || status !== 'success') {
          svs.myProfile.logger.debug('handleMarketplaceCheckbox: error: ', error);
          showSettingsTechnicalError();
        } else {
          trackMarketplace(!isChecked);
          svs.myProfile.logger.debug('handleMarketplaceCheckbox: success :)');
          setPlayerMarketplaceData(newModel);
        }
      } catch (error) {
        showSettingsTechnicalError();
        svs.myProfile.logger.debug('handleMarketplaceCheckbox: error: ', error);
      }
    }
  };
  let isChecked = false;
  ID.forEach(id => {
    var _notification$transpo;
    const notification = playerMarketplaceData === null || playerMarketplaceData === void 0 ? void 0 : playerMarketplaceData.find(item => item.notificationType === id);
    const checked = notification === null || notification === void 0 || (_notification$transpo = notification.transports) === null || _notification$transpo === void 0 ? void 0 : _notification$transpo.find(item => item.transportType === 'Mail');
    if (checked !== null && checked !== void 0 && checked.enabled) {
      isChecked = true;
    }
  });
  return React.createElement("div", null, playerMarketplaceData && playerMarketplaceData.length > 0 && React.createElement("div", {
    className: "margin-top-2"
  }, React.createElement(TopHeader, {
    icon: icons.FRACTIONGAME,
    title: titles.FRACTIONGAME
  }), React.createElement("p", null, "V\xE4lj om du vill f\xE5 mejl med uppdateringar om andelsspel du har k\xF6pt. Du f\xE5r notifieringar n\xE4r alla andelar i ett andelsspel s\xE4ljs och din reservation omvandlas till ett k\xF6p, samt om ett andelsspel blir inst\xE4llt och din reservation \xE5terbetalas."), React.createElement(Fieldset, {
    legend: titles.FRACTIONGAME,
    srOnly: true
  }, React.createElement(Checkbox, {
    checked: isChecked,
    onChange: () => handleMarketplaceCheckbox(isChecked)
  }, "Skicka uppdateringar om andelsspel jag har k\xF6pt"))));
};
svs.myProfile.react.pages.notifications.components.Marketplace = Marketplace;

 })(window);